import { TagManager } from '../tags/TagManager';

// TAB Tag: gestione tag + collezioni (parent_id). Vedi TagManager.
export function TagsTab() {
  return <TagManager />;
}
